<template>
  <div>
    <table
      class="table is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium is-marginless has-cells-vcentered"
      v-if="accesses && accesses.length">
      <thead>
        <tr class="is-size-6">
          <th></th>
          <th v-if="isPromoteur && displayCompany">
            Société
          </th>
          <th v-else-if="!isPromoteur && displayCompany">
            Promoteur
          </th>
          <th v-if="displayProgram">
            Programme
          </th>
          <th>Date de début</th>
          <th>Date de fin</th>
          <th></th>
          <th>Rémunération</th>
        </tr>
      </thead>
      <access-light-list-item
        class="is-size-5 has-text-text"
        v-for="(a, i) in accesses"
        :key="i"
        :program="program"
        :lots="lots"
        :source="a"
        :loading-access="loading"
        :allotments="allotments"
        :accesses="accesses"
        :selected-access="selectedAccess"
        @deleteAccess="val => $emit('deleteAccess', val)"
        @updateAccessAllotment="updateAccessAllotment"
        @updateAccess="updateAccess"
        @selectedAccess="val => selectedAccess = val">
      </access-light-list-item>
    </table>
    <div
      class="is-padding"
      v-else>
      Aucun mandat à afficher
    </div>
    <pagination
      class="has-background-transparent"
      :loading="false"
      :current-page="currentAccessPage"
      :total-page="currentAccessTotalPage"
      @changePage="loadItems($event)" />
  </div>
</template>

<script>
import { Error } from '@/mixins'
import { differenceBy } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'AccessLightList',
  components: {
    AccessLightListItem: () => import('./AccessLightListItem')
  },
  mixins: [Error],
  props: {
    allotments: {
      type: Array
    },
    accesses: {
      type: Array,
      require: true
    },
    accessesCount: {
      type: Number
    },
    currentAccessPage: {
      type: Number
    },
    currentAccessTotalPage: {
      type: Number
    },
    program: Object,
    lots: Array
  },
  data () {
    return {
      loading: false,
      selectedAccess: null
    }
  },
  computed: {
    ...mapGetters(['isPromoteur']),
    /**
      * display company if route isn't relation
      * @returns {boolean}
      */
    displayCompany () {
      return !this.$route.path.split('/').includes('relations') && !this.$route.path.split('/').includes('societes')
    },
    /**
      * display program if route isn't program
      * @returns {boolean}
      */
    displayProgram () {
      return !this.$route.path.split('/').includes('programmes')
    }
  },
  methods: {
    loadItems (page) {
      this.$emit('loadAccessPage', page)
    },
    /**
      * post allotments or delete then update access
      * @param {object} access - access object with allotments
      */
    async updateAccessAllotment (access) {
      this.loading = true
      if (access.newAllotments) {
        let oldLots = []
        if (access.lots.length) {
          for (let lot of access.lots) {
            let value = {
              pk: lot.lot.pk,
              allotment_pk: lot.pk
            }
            oldLots.push(value)
          }
        }
        let toCreate = differenceBy(access.newAllotments, oldLots, x => x.pk)
        let toDelete = differenceBy(oldLots, access.newAllotments, x => x.pk)
        if (toCreate && toCreate.length) {
          const payload = {
            access: access.pk,
            lots: toCreate.map(x => x.pk)
          }
          try {
            await this.$api.axios.post(`allotments`, payload)
          } catch (err) {
            console.log(err)
            this.handleError(err)
          }
        }
        if (toDelete && toDelete.length) {
          for (let elem of toDelete) {
            try {
              await this.$api.axios.delete(`allotments/${elem.allotment_pk}`)
            } catch (err) {
              console.log(err)
              this.handleError(err)
            }
          }
        }
      }
      this.updateAccess(access)
    },
    /**
      * patch access then emit updateAccess in ProgramAccesses
      * @param {object} access - access object to patch
      */
    async updateAccess (access) {
      this.loading = true
      try {
        await this.$api.patch(this.$resources.ACCESS, access.pk, access)
        this.$toasted.global.success('Le mandat à été mis à jour.')
        this.$emit('updateAccess', access)
      } catch (e) {
        this.$toasted.global.danger('Erreur lors de la mise à jour du mandat.')
      }
      this.loading = false
      this.selectedAccess = null
    }
  }
}
</script>
